import { ReactNode, useState } from "react";

import { Menu, MenuItem, Position } from "@blueprintjs/core";

import { Popover } from "@/components/helpers/ui/blueprint-overrides/Popover";
import { StyledButton } from "@/components/pieces/link/LinkButton";
import { FullReview } from "@/types/meetings";

interface ReviewHeaderButtonProps {
  review: FullReview;
  isCoach: boolean;
  label: ReactNode;
  setShowCancel: (show: boolean) => void;
}

export function ReviewHeaderButton({
  review,
  isCoach,
  label,
  setShowCancel,
}: ReviewHeaderButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const showMenuButton =
    !review.canceledAt &&
    !review.completedAt &&
    (!review.acceptedAt || isCoach);

  if (!showMenuButton) {
    return null;
  }

  const menuContent = (
    <Menu>
      <MenuItem
        onClick={() => {
          setShowCancel(true);
          setIsOpen(false);
        }}
        text="Cancel"
        icon="trash"
      />
    </Menu>
  );

  return (
    <Popover
      content={menuContent}
      canEscapeKeyClose={true}
      position={Position.BOTTOM_RIGHT}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <span>
        <StyledButton onClick={() => setIsOpen(!isOpen)}>{label}</StyledButton>
      </span>
    </Popover>
  );
}
